import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'sd-add-payment',
  templateUrl: './add-payment.component.html',
  styleUrls: ['./add-payment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorAddPaymentComponent {}
